import axios from 'axios/dist/browser/axios.cjs';
import config from 'config';
import EventEmitter from 'utils/events';
import { EVENT_API_DOWN, EVENT_API_LOGGED_OUT } from 'utils/constants';
import helpers from 'utils/helpers';

const baseURL = config.API_URL;
const axiosInstance = axios.create({
    baseURL
});

const responseHandler = response => {
    // do nothing
    // console.log('axios intercept responseHandler', response.status)
    return response;
};

const errorHandler = error => {
    let errorDetails = '';

    if (error && error.response && error.response.status) {
        const status = error.response.status;

        // check if API is down (503 only)
        if (status === 503) {
            errorDetails = { details: 'sending event API is in maintenance mode' };
            EventEmitter.dispatch(EVENT_API_DOWN, {});
        }

        // check if user is logged out
        if (
            status === 401 &&
            error.response.data &&
            error.response.data.message &&
            error.response.data.message.search('logged out') !== -1
        ) {
            errorDetails = { details: 'user is logged out?' };
            EventEmitter.dispatch(EVENT_API_LOGGED_OUT, {});
        }

        // Send 5xx errors to Datadog with a descriptive message so they get
        // grouped by status code + endpoint instead of all lumped together.
        // Examples: "HTTP 504: GET /people", "HTTP 502: POST /screeners/123/answers"
        if (![400, 401, 403, 404, 429].includes(status)) {
            let method = '';
            let path = 'unknown';

            try {
                method = ((error.config && error.config.method) || '').toUpperCase();
                // Use URL API to safely extract just the pathname, stripping query strings.
                // A base is required because axios URLs are relative (e.g. "/people?account_id=1").
                const fullUrl = (error.config && error.config.url) || '';
                path = new URL(fullUrl, 'http://placeholder').pathname || 'unknown';
            } catch (e) {
                // If URL parsing fails for any reason, fall back to defaults above
            }

            const trackingError = new Error(`HTTP ${status}: ${method} ${path}`);
            trackingError.stack = error.stack;
            helpers.trackError(trackingError, errorDetails);
        }
    }

    return Promise.reject(error);
};

axiosInstance.interceptors.response.use(
    response => responseHandler(response),
    error => errorHandler(error)
);

export default axiosInstance;
